import { AnyAction, Reducer } from 'redux';

export const STORE_SUPPORT_REQUEST_DATA = 'store/support-request-data';
export const STORE_SUPPORT_TICKETNO = 'store/support-ticketno';
export const STORE_SUPPORT_DATE = 'store/support-date';
export const STORE_SUPPORT_SUPPORTTYPE = 'store/support-supporttype';
export const STORE_SUPPORT_STATUS = 'store/support-status';
export const STORE_SUPPORT_MTYPE = 'store/support-type';
export const STORE_SUPPORT_CASENO = 'store/caseno';
export const STORE_SUPPORT_REQUEST_TYPES = 'store/support-request-types';

export interface SupportRequest {
    rowno: string;
    ticketno: string;
    createdby: string;
    createdon: string;
    customercode: string;
    customername: string;
    supporttype: string;
    mtype: string;
    caseno: string;
    dsorderid: string;
    status: string;
    tstatus: number;
}

export interface SupportRequestTypes {
    rowno: string;
    active: string;
    mt_code: string;
    mt_name: string;
}

export interface SupportRequestPayload {
    ticketno: string;
    comments: string;
    orderno: string;
    status: string;
}

export interface SupportRequestState {
    supportRequestData: SupportRequest[];
    ticketno: string;
    date: string;
    supporttype: string;
    status: string;
    mtype: string;
    caseno: string;
    supportRequestTypes: SupportRequestTypes[];
}

const initialState: SupportRequestState = {
    supportRequestData: [{
        rowno: '1',
        ticketno: '',
        createdby: '',
        customercode: '',
        customername: '',
        supporttype: '',
        mtype: '',
        status: '',
        createdon: '',
        caseno: '',
        dsorderid: '',
        tstatus: 0
    }],
    ticketno: '',
    date: '',
    supporttype: '',
    mtype: '',
    caseno: '',
    status: '',
    supportRequestTypes: []
};

const reducer: Reducer<SupportRequestState> = (state: SupportRequestState = initialState, action: AnyAction): SupportRequestState => {
    switch (action.type) {
        case STORE_SUPPORT_REQUEST_DATA:
            return {
                ...state,
                supportRequestData: action.supportRequestData
            };
        case STORE_SUPPORT_TICKETNO:
            return {
                ...state,
                ticketno: action.ticketno
            };
        case STORE_SUPPORT_DATE:
            return {
                ...state,
                date: action.date
            };
        case STORE_SUPPORT_SUPPORTTYPE:
            return {
                ...state,
                supporttype: action.supporttype
            };
        case STORE_SUPPORT_STATUS:
            return {
                ...state,
                status: action.status
            };
        case STORE_SUPPORT_MTYPE:
            return {
                ...state,
                mtype: action.mtype
            };
        case STORE_SUPPORT_REQUEST_TYPES:
            return {
                ...state,
                supportRequestTypes: action.supportRequestTypes
            };
        case STORE_SUPPORT_CASENO:
            return {
                ...state,
                caseno: action.caseno
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/supportRequest.tsx